import { createFileRoute } from '@tanstack/react-router'

import { requireAdminAccess } from '@/utils/router/redirects'
import { DocumentsView } from '@/views/documents/DocumentsView'

export const Route = createFileRoute('/documents/')({
  component: DocumentsView,
  beforeLoad: async () => {
    await requireAdminAccess()
  },
})
